module.exports = __webpack_public_path__ + "static/img/font-7.199be984.svg";